(function () {
    "use strict";

    angular.module("app").filter("remarks", RemarksFilterFactory);

    function RemarksFilterFactory() {
        return (remarks, sections) => {
            if (!remarks)
                return false;

            return remarks.filter(r => sections.some(s => s === r.Section));
        };
    }
})();